<script lang="ts">
    import { Dialog, Modal, Tabs } from 'attractions';
    import { clearPickedEmployee } from '../../Stores/Report';
    import EmployeePurchasesClearance from './EmployeePurchasesClearance/EmployeePurchasesClearance.svelte';
    import PickEmployeeToReport from './EmployeePurchasesReport/PickEmployeeToReport.svelte';

    export let open: boolean;

    const availableTabs = ["Generowanie raportu", "Rozliczenia"];

    let slideIndex = -1;
    let selectedTab: string = availableTabs[0];

    function handleModalState(e) {
        const modalOpen = e.detail.value;
        if (!modalOpen) {
            slideIndex = -1;
            clearPickedEmployee();
        } else {
            slideIndex = 0;
        }
    }
</script>


<Modal on:change={handleModalState} bind:open let:closeCallback>
    <Dialog title="Raporty zakupów" {closeCallback}>
        <Tabs
            class="modalTabs"
            name="menu"
            items={availableTabs}
            bind:value={selectedTab}
        />
        {#if selectedTab == availableTabs[0]}
            <PickEmployeeToReport bind:slideIndex />
        {/if}
        <section class="modalContent">
            {#if selectedTab == availableTabs[1]}
                <EmployeePurchasesClearance />
            {/if}
        </section>
    </Dialog>
</Modal>